<div class="container">
  <div class="d-flex">
    <div [innerHtml]="SVG_ICONS.BACK_BUTTON() | sanitizer : 'html'" routerLink="/members" class="cursor-pointer"></div>
    <div class="font-white fs-14 fw-bold mt-1 ms-2">Profile Details</div>
  </div>
  <div class="profile-card p-2 position-relative bg-card mt-4">
    <div class="z-2 position-relative row align-items-center h-100 mx-3">
      <div class="col-md-6 col-12 d-flex align-items-center gap-2">
        <img src="public/profile-img.png" alt="Profile" class="profile-img" />
        <div class="">
          <div class="fw-bold fs-32">{{ studentDetails?.FirstName }} {{ studentDetails?.LastName }}</div>
          <div class="fw-bold fs-14">{{ studentDetails?.StudentID }}</div>
        </div>
      </div>
      <div class="col-md-6 col-12 d-flex justify-content-end">
        <button class="border-0 bg-gray border-radius-10 px-3">
          <div class="d-flex align-items-center gap-2" (click)="editStudent()" (keydown.enter)="editStudent()" tabindex="0" role="button">
            <div [innerHTML]="SVG_ICONS.EDIT() | sanitizer : 'html'"></div>
            <!-- <div class="font-white" (click)="editProfile()" (keydown.enter)="editProfile()" tabindex="0" role="button">Edit</div> -->
            <div class="font-white" role="button">Edit</div>
          </div>
        </button>
        <!-- <button class="border-0 bg-none ms-3" (click)="editProfile()"> -->
        <button class="border-0 bg-none ms-3">
          <div [innerHTML]="SVG_ICONS.EDIT_ICON(40, 40) | sanitizer : 'html'"></div>
        </button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-8 col-12">
      <div class="card mt-4 border-black bg-card font-white">
        <div class="row mx-3">
          <div class="col-lg-3 col-6 mt-3">
            <div class="font-gray fs-14 fw-semibold">Full Name</div>
            <div class="font-white fs-14 fw-bold">{{ studentDetails?.FirstName + " " + studentDetails?.LastName }}</div>
          </div>
          <div class="col-lg-3 col-6 mt-3">
            <div class="font-gray fs-14 fw-semibold">DOB</div>
            <div class="font-white fs-14 fw-bold">{{ studentDetails?.DOB | date : "dd/MM/yyyy" }}</div>
          </div>
          <div class="col-lg-3 col-6 mt-3">
            <div class="font-gray fs-14 fw-semibold">Gender</div>
            <div class="font-white fs-14 fw-bold">{{ studentDetails?.Gender }}</div>
          </div>
          <div class="col-lg-3 col-6 mt-3">
            <div class="font-gray fs-14 fw-semibold">Center Location</div>
            <div class="font-white fs-14 fw-bold">{{ studentDetails?.CenterID }}</div>
          </div>
        </div>
        <div class="row mx-3">
          <div class="col-12 mt-3">
            <div class="font-gray fs-14 fw-semibold">Email ID</div>
            <div class="font-white fs-14 fw-bold">{{ studentDetails?.Email }}</div>
          </div>
          <div class="col-md-4 col-6 mt-3">
            <div class="font-gray fs-14 fw-semibold">Phone Number</div>
            <div class="font-white fs-14 fw-bold">{{ studentDetails?.MobileNo }}</div>
          </div>
          <div class="col-md-4 col-6 mt-3">
            <div class="font-gray fs-14 fw-semibold">Emergency Contact</div>
            <div class="font-white fs-14 fw-bold">{{ studentDetails?.EmergencyContact }}</div>
          </div>
        </div>

        <div class="mt-3">
          <div class="card bg-gray font-white border-radius-3">
            <div class="row mx-4">
              <div class="d-flex align-items-center gap-2 col-lg-3 col-6 mt-3 mb-3">
                <div [innerHTML]="SVG_ICONS.WEIGHT_ICON() | sanitizer : 'html'"></div>
                <div>
                  <div class="fs-12 fw-normal font-white">Weight</div>
                  <div class="fs-18 fw-bold font-white">{{ studentDetails?.Weight }}kg</div>
                </div>
              </div>
              <div class="d-flex align-items-center gap-2 col-lg-3 col-6 mt-3 mb-3">
                <div [innerHTML]="SVG_ICONS.HEIGHT_ICON() | sanitizer : 'html'"></div>
                <div>
                  <div class="fs-12 fw-normal font-white">Height</div>
                  <div class="fs-18 fw-bold font-white">{{ studentDetails?.Height }} ft</div>
                </div>
              </div>
              <div class="d-flex align-items-center gap-2 col-lg-3 col-6 mt-3 mb-3">
                <div [innerHTML]="SVG_ICONS.FLEXIBILITY_ICON() | sanitizer : 'html'"></div>
                <div>
                  <div class="fs-12 fw-normal font-white">Flexibility</div>
                  <div class="fs-18 fw-bold font-white font-dark-green">{{ studentDetails?.Flexibility }}</div>
                </div>
              </div>
              <div class="d-flex align-items-center gap-2 col-lg-3 col-6 mt-3 mb-3">
                <div [innerHTML]="SVG_ICONS.BMI_ICON() | sanitizer : 'html'"></div>
                <div>
                  <div class="fs-12 fw-normal font-white">BMI</div>
                  <div class="fs-18 fw-bold font-dark-green">{{ bmi | number : "1.1-2" }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 p-3">
          <div class="font-gray fs-14 fw-semibold">Address</div>
          <div class="font-white fs-14 fw-bold">{{ studentDetails?.Address }}</div>
        </div>
        <!-- <div class="p-3">
          <div class="font-gray fs-14 fw-semibold">Medical History</div>
          <div class="d-flex gap-2 mt-2">
            <div class="specialization-btn px-2">Asthama</div>
            <div class="specialization-btn px-2">Injuries</div>
          </div>
        </div> -->
      </div>
      <div class="card mt-4 border-black bg-card font-white">
        <div class="mx-3 my-2">
          <div class="font-white fs-16 fw-bold">Attendance</div>
          <div class="font-white fs-14 fw-normal">Previous attendance of member</div>
        </div>
        <hr />
        <div class="p-3">
          <div class="table-responsive-scroll">
            <div class="d-flex justify-content-center gap-5">
              <div>
                <div class="font-gray fs-12 fw-bold mb-2 ms-2">21 Jan</div>
                <div [innerHTML]="SVG_ICONS.ATTENDENCE_ICON('var(--fill-color-gray-bg)', 'var(--fill-color-gray)', 50, 50) | sanitizer : 'html'"></div>
              </div>
              <div>
                <div class="font-gray fs-12 fw-bold mb-2 ms-2">22 Jan</div>
                <div [innerHTML]="SVG_ICONS.ATTENDENCE_ICON('var(--fill-color-red-bg)', 'var(--fill-color-red)', 50, 50) | sanitizer : 'html'"></div>
              </div>
              <div>
                <div class="font-gray fs-12 fw-bold mb-2 ms-2">23 Jan</div>
                <div [innerHTML]="SVG_ICONS.ATTENDENCE_ICON('var(--fill-color-green-bg)', 'var(--fill-color-green)', 50, 50) | sanitizer : 'html'"></div>
              </div>
              <div>
                <div class="font-gray fs-12 fw-bold mb-2 ms-2">24 Jan</div>
                <div [innerHTML]="SVG_ICONS.ATTENDENCE_ICON('var(--fill-color-gray-bg)', 'var(--fill-color-gray)', 50, 50) | sanitizer : 'html'"></div>
              </div>
              <div>
                <div class="font-gray fs-12 fw-bold mb-2 ms-2">23 Jan</div>
                <div [innerHTML]="SVG_ICONS.ATTENDENCE_ICON('var(--fill-color-green-bg)', 'var(--fill-color-green)', 50, 50) | sanitizer : 'html'"></div>
              </div>
              <div>
                <div class="font-gray fs-12 fw-bold mb-2 ms-2">24 Jan</div>
                <div [innerHTML]="SVG_ICONS.ATTENDENCE_ICON('var(--fill-color-red-bg)', 'var(--fill-color-red)', 50, 50) | sanitizer : 'html'"></div>
              </div>
              <div>
                <div class="font-gray fs-12 fw-bold mb-2 ms-2">23 Jan</div>
                <div [innerHTML]="SVG_ICONS.ATTENDENCE_ICON('var(--fill-color-green-bg)', 'var(--fill-color-green)', 50, 50) | sanitizer : 'html'"></div>
              </div>
              <div>
                <div class="font-gray fs-12 fw-bold mb-2 ms-2">24 Jan</div>
                <div [innerHTML]="SVG_ICONS.ATTENDENCE_ICON('var(--fill-color-gray-bg)', 'var(--fill-color-gray)', 50, 50) | sanitizer : 'html'"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="card bg-gray font-white">
          <div class="row">
            <div class="p-3 d-flex gap-4 col-md-6 col-12">
              <div class="font-white fs-14 fw-bold">
                TOTAL CLASS : <span>{{ totalDays }}</span>
              </div>
              <div class="font-dark-green fs-14 fw-bold">
                ATTENDED : <span>{{ presentDays }}</span>
              </div>
              <div class="font-red-light fs-14 fw-bold">
                MISSED : <span>{{ totalDays - presentDays }}</span>
              </div>
            </div>
            <div class="p-3 col-md-6 col-12">
              <div>
                ATTENDANCE RATE <span>{{ attendanceRate }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card border-black bg-card font-white mt-4">
        <div class="mx-3 my-2">
          <div class="d-flex justify-content-between">
            <div>
              <div class="font-white fs-16 fw-bold">Attendance</div>
              <div class="font-white fs-14 fw-normal">Previous attendance of member</div>
            </div>
            <div class="d-flex gap-2">
              <div class="d-flex align-items-center gap-2 bg-gray border-radius-10 px-3">
                <div [innerHTML]="SVG_ICONS.ASSES_ICON() | sanitizer : 'html'"></div>
                <div class="font-white fs-14 fw-bold">Assess</div>
              </div>
              <div [innerHTML]="SVG_ICONS.EDIT_ICON(42, 42) | sanitizer : 'html'"></div>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <div class="table-responsive-scroll">
            <table class="w-100">
              <thead class="bg-gray">
                <tr>
                  <th class="fs-14 fw-bold font-white p-3">Metric</th>
                  <th class="fs-14 fw-bold font-white p-3">Initial</th>
                  <th class="fs-14 fw-bold font-white p-3">Last Week</th>
                  <th class="fs-14 fw-bold font-white p-3">Current</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for(item of performanceData; track $index){
                <tr class="border-bottom">
                  <td class="p-3">{{ item.Metric }}</td>
                  <td class="p-3">{{ item.Initial }}</td>
                  <td class="p-3">{{ item.LastWeek }}</td>
                  <td class="p-3">{{ item.Current }}</td>
                  <td>
                    <button class="plan-status-btn d-flex align-items-center gap-1">
                      <div [innerHtml]="SVG_ICONS.UP_ICON() | sanitizer : 'html'"></div>
                      <div class="font-dark-green fs-14 fw-bold">2.0</div>
                    </button>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="card border-black bg-card font-white mt-4">
        <div class="mx-3 my-2">
          <div class="d-flex justify-content-between">
            <div>
              <div class="font-white fs-16 fw-bold">Attachment</div>
              <div class="font-white fs-14 fw-normal">Previous attachments of member</div>
            </div>
            <div class="d-flex gap-2">
              <div class="d-flex align-items-center gap-2 bg-gray border-radius-10 px-3">
                <div [innerHTML]="SVG_ICONS.UPLOAD_IMAGE() | sanitizer : 'html'"></div>
                <div class="font-white fs-14 fw-bold">Upload</div>
              </div>
              <div [innerHTML]="SVG_ICONS.EDIT_ICON(42, 42) | sanitizer : 'html'"></div>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <div class="table-responsive-scroll">
            <table class="w-100">
              <thead class="bg-gray">
                <tr>
                  <th class="fs-14 fw-bold font-white p-3">Document Name</th>
                  <th class="fs-14 fw-bold font-white p-3">Upload Date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for(item of attachmentData; track $index){
                <tr class="border-bottom">
                  <td class="p-3">{{ item.name }}</td>
                  <td class="p-3">{{ item.Date }}</td>
                  <td class="d-flex gap-2 mt-2 justify-content-end">
                    <div class="d-flex align-items-center gap-2 border-gray border-radius-10 px-3">
                      <div [innerHTML]="SVG_ICONS.VIEW_ICON() | sanitizer : 'html'"></div>
                      <div>View</div>
                    </div>
                    <button class="border-0 bg-none">
                      <div [innerHtml]="SVG_ICONS.DESC_ICON() | sanitizer : 'html'"></div>
                    </button>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="card border-black bg-card font-white mt-4">
        <div class="mx-3 my-2">
          <div class="d-flex justify-content-between">
            <div>
              <div class="font-white fs-16 fw-bold">Payments</div>
              <div class="font-white fs-14 fw-normal">Previous payments of member</div>
            </div>
            <div class="d-flex gap-2">
              <div class="d-flex align-items-center gap-2 bg-gray border-radius-10 px-3">
                <div [innerHTML]="SVG_ICONS.RENEW_ICON() | sanitizer : 'html'"></div>
                <div class="font-white fs-14 fw-bold">Renew</div>
              </div>
              <div [innerHTML]="SVG_ICONS.EDIT_ICON(42, 42) | sanitizer : 'html'"></div>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <div class="table-responsive-scroll">
            <table class="w-100">
              <thead class="bg-gray">
                <tr>
                  <th class="fs-14 fw-bold font-white p-3">Payment ID</th>
                  <th class="fs-14 fw-bold font-white p-3">Plan</th>
                  <th class="fs-14 fw-bold font-white p-3">Payment Date</th>
                  <th class="fs-14 fw-bold font-white p-3">Status</th>
                  <th class="fs-14 fw-bold font-white p-3">Mode</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for(item of data; track $index){
                <tr class="border-bottom">
                  <td class="p-3">{{ item.TxnID }}</td>
                  <td class="p-3">
                    <span class="membership-pill">
                      <img src="public/gold-membership.png" alt="coin-icon" />
                      {{ item.Plan }}
                    </span>
                  </td>
                  <td class="p-3">{{ item.Date }}</td>
                  <td class="p-3">
                    <button class="plan-status-btn justify-content-center px-2">
                      <div [innerHtml]="SVG_ICONS.PAID_ICON() | sanitizer : 'html'"></div>
                      <div class="ms-2 font-dark-green fs-14 fw-bold">{{ item.Status }}</div>
                    </button>
                  </td>
                  <td class="p-3 font-white fs-14 fw-bold">{{ item.Mode }}</td>
                  <td>
                    <button class="border-0 bg-none">
                      <div [innerHtml]="SVG_ICONS.DESC_ICON() | sanitizer : 'html'"></div>
                    </button>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-12">
      <div class="mt-4">
        <div class="membership-card border-radius-10 d-flex align-items-center font-white p-3">
          <div [innerHTML]="SVG_ICONS.GOLD_BADGE() | sanitizer : 'html'"></div>
          <div class="ms-3">
            <div class="fw-bold fs-18">{{ packageDetails?.PackageName }}</div>
            <div class="fw-bold fs-12">5hr week</div>
            <div class="fw-normal fs-12">Expires on {{ packageDetails?.EndTime | date : "dd/MM/yyyy" }}</div>
          </div>
        </div>
        <div class="card bg-card font-white d-flex justify-content-between border-radius-10 p-3 mt-4 position-relative">
          <div class="z-2 font-white">
            <div class="fs-12 fw-normal">Parents Details</div>
            <div class="fs-16 fw-bold mt-3">{{ studentDetails?.ParentFirstName + " " + studentDetails?.ParentLastName }}</div>
            <div class="fs-12 fw-bold">{{ studentDetails?.Relation }}</div>

            <div class="d-flex align-items-center gap-2 mt-3">
              <div [innerHTML]="SVG_ICONS.CALL_ICON() | sanitizer : 'html'"></div>
              <div class="fs-12 fw-bold">{{ studentDetails?.ParentContactNO }}</div>
            </div>

            <div class="d-flex align-items-center gap-2 mt-2">
              <div [innerHTML]="SVG_ICONS.EMAIL_ICON() | sanitizer : 'html'"></div>
              <div class="fs-12 fw-bold">{{ studentDetails?.ParentEmail }}</div>
            </div>
          </div>

          <div class="person-icon position-absolute bottom-0">
            <div [innerHTML]="SVG_ICONS.PERSON_ICON() | sanitizer : 'html'"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
